(function () {
  'use strict';

  if (window.Rolife9thAnniversary) {
    window.Rolife9thAnniversary.refresh();
    return;
  }

  var controllers = new WeakMap();
  var themeClasses = [
    'r9-theme-intro-cover',
    'r9-theme-intro',
    'r9-theme-gold',
    'r9-theme-community',
    'r9-theme-online',
    'r9-theme-offline',
    'r9-theme-preview',
    'r9-theme-black',
  ];
  var themeConfig = {
    'intro-cover': { bg: '#ff7e17', ink: '#fff', grid: '#f26403' },
    intro: { bg: '#352118', ink: '#fff', grid: '#442d24' },
    gold: { bg: '#f799bd', ink: '#fff', grid: '#ffb0d0' },
    community: { bg: '#f8cb5e', ink: '#fff', grid: '#ffb829' },
    online: { bg: '#73a7e5', ink: '#050505', grid: '#86b1ef' },
    offline: { bg: '#9f2524', ink: '#fff', grid: '#871717' },
    preview: { bg: '#141414', ink: '#fff', grid: '#000' },
    black: { bg: '#020202', ink: '#fff', grid: 'rgba(255, 255, 255, 0.12)' },
  };
  var followWidths = [107, 139, 171, 175, 193, 204];
  var introMouseFollowConfig = {
    baseViewportWidth: 1920,
    imageScale: 0.8,
    minDistance: 56,
    minInterval: 54,
    lifetime: 760,
    driftMax: 54,
    poolSize: 5,
  };
  var socialOrbitConfig = {
    normalRate: 1,
    hoverRate: 0.12,
    easing: 0.16,
  };
  var navMagnetConfig = {
    radius: 240,
    falloff: 2.1,
    maxScale: 1.18,
    maxLift: 7,
  };
  var clickEffectConfig = {
    color: '#ffffff',
    particleCount: 8,
    duration: 300,
    particleSize: 2,
    effectSize: 90,
    maxActiveParticles: 96,
  };
  var swipeConfig = {
    minimumDistance: 48,
    axisRatio: 1.25,
    clickSuppressMs: 450,
  };
  var craftimeNavSections = [
    'creator-business',
    'engagement-gap',
    'burnt-out',
    'on-social',
  ];

  function clamp(value, minimum, maximum) {
    return Math.min(Math.max(value, minimum), maximum);
  }

  function asArray(value) {
    return Array.prototype.slice.call(value || []);
  }

  function isCraftimeNavSection(section) {
    return craftimeNavSections.indexOf(section) !== -1;
  }

  function getAnniversaryRoots() {
    return asArray(document.querySelectorAll('[data-r9-anniversary]'));
  }

  function syncAnniversaryPageClass(excludedRoot) {
    if (!document.body) return;
    var shouldHideThemeChrome = getAnniversaryRoots().some(function (candidate) {
      return candidate !== excludedRoot && candidate.dataset.r9HideThemeChrome === 'true';
    });
    document.body.classList.toggle('r9-anniversary-page', shouldHideThemeChrome);
  }

  function getFollowImages(root) {
    var images = [];
    for (var index = 1; index <= 6; index += 1) {
      var source = root.getAttribute('data-r9-follow-' + index);
      if (source) images.push({ src: source, width: followWidths[index - 1] });
    }
    return images;
  }

  function initAnniversary(root) {
    if (!root || controllers.has(root)) return;

    syncAnniversaryPageClass();

    var deck = root.querySelector('[data-r9-deck]');
    var stage = root.querySelector('[data-r9-stage]');
    var cards = asArray(root.querySelectorAll('[data-r9-card]'));
    if (!deck || !stage || !cards.length) return;

    var navItems = asArray(root.querySelectorAll('[data-r9-nav-section]')).filter(function (item) {
      return item.matches('.r9-nav-item');
    });
    var chapterNav = root.querySelector('.r9-chapter-nav');
    var mobileToggle = root.querySelector('[data-r9-mobile-toggle]');
    var clusterToggle = root.querySelector('[data-r9-nav-cluster]');
    var mobileLabel = root.querySelector('[data-r9-mobile-label]');
    var mobileProgress = root.querySelector('[data-r9-mobile-progress]');
    var startButton = root.querySelector('[data-r9-start]');
    var coverControls = root.querySelector('[data-r9-cover-controls]');
    var coverStepButtons = asArray(root.querySelectorAll('[data-r9-cover-step]'));
    var footer = root.querySelector('.r9-site-footer');
    var liveRegion = root.querySelector('[data-r9-live]');
    var pointerLayer = root.querySelector('[data-r9-pointer-layer]');
    var socialOrbitRingFrame = root.querySelector('.r9-social-orbit-ring-frame');
    var socialOrbitRing = root.querySelector('.r9-social-orbit-ring');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var finePointer = window.matchMedia('(pointer: fine)');
    var mobileViewport = window.matchMedia('(max-width: 760px)');
    var followImages = getFollowImages(root);
    var cleanups = [];
    var timeouts = new Set();
    var frame = 0;
    var copyFitFrame = 0;
    var deckMetrics = null;
    var activeIndex = 0;
    var renderedActiveIndex = -1;
    var currentProgress = 0;
    var wheelGestureTimer = 0;
    var wheelGestureActive = false;
    var wheelScrollTargetIndex = -1;
    var wheelGestureIdleMs = 160;
    var programmaticScrollInProgress = false;
    var programmaticTargetIndex = -1;
    var supportsScrollEnd = 'onscrollend' in document;
    var wheelBlockerAttached = false;
    var interactionIsolation = [];
    var lastMobileViewport = mobileViewport.matches;
    var cardPosesInitialized = false;
    var poseWindowStart = 0;
    var poseWindowEnd = -1;
    var visible = true;
    var pointerPool = [];
    var pointerTimers = [];
    var followPreloads = [];
    var pointerIndex = 0;
    var lastPointer = { x: 0, y: 0, time: 0 };
    var mobileNavItems = [];
    var activeMobileNavLevel = '';
    var activeMobileNavSection = '';
    var clickEffectsLayer = null;
    var swipePointer = null;
    var mobileNavSwipePointer = null;
    var suppressNextClick = false;
    var suppressClickTimer = 0;
    var activeCityDialog = null;
    var activeCityTrigger = null;
    var cityDialogHideTimer = 0;
    var cityFocusTimer = 0;
    var confirmedCityName = '';
    var cityDeviceStorageKey = 'rolife-9th-city-device:v1';
    var citySubmissionStorageKey = 'rolife-9th-city-submission:v1';
    var citySubmissionWindow = 24 * 60 * 60 * 1000;
    var socialOrbitMotion = {
      frame: 0,
      rate: socialOrbitConfig.normalRate,
      targetRate: socialOrbitConfig.normalRate,
    };
    var defaultStartLabel = startButton ? startButton.textContent.trim() : 'START SCROLLING';
    var navMeta = buildNavMeta();
    var cardRuntimeByElement = new WeakMap();
    var cardRuntime = cards.map(function (card, index) {
      var navGroup = card.dataset.r9NavSection || card.dataset.r9Section;
      var groupMeta = navMeta.get(navGroup);
      var runtime = {
        card: card,
        index: index,
        navGroup: navGroup,
        navLocalIndex: groupMeta ? Math.max(groupMeta.cards.indexOf(card), 0) : 0,
        controls: asArray(card.querySelectorAll('a[href], button, input, select, textarea, [tabindex]')).map(function (control) {
          return {
            element: control,
            tabindex: control.getAttribute('tabindex'),
          };
        }),
        tabindex: card.getAttribute('tabindex'),
        isActive: null,
        canPoint: null,
        isIntroCoverMode: null,
      };
      cardRuntimeByElement.set(card, runtime);
      return runtime;
    });
    var coverStepRuntime = coverStepButtons.map(function (button) {
      var labelElement = button.querySelector('.r9-cover-step-label');
      return {
        button: button,
        direction: Number(button.dataset.r9CoverStep),
        label: labelElement ? labelElement.textContent.trim() : 'Navigate',
      };
    });

    function listen(target, type, handler, options) {
      if (!target || !target.addEventListener) return;
      target.addEventListener(type, handler, options);
      cleanups.push(function () {
        target.removeEventListener(type, handler, options);
      });
    }

    function addTimeout(callback, delay) {
      var id = window.setTimeout(function () {
        timeouts.delete(id);
        callback();
      }, delay);
      timeouts.add(id);
      return id;
    }

    function clearTrackedTimeout(id) {
      if (!id) return;
      window.clearTimeout(id);
      timeouts.delete(id);
    }

    function getCopyFitNodes(card) {
      var content = null;
      var first = null;
      var last = null;

      if (card.classList.contains('r9-section-cover-card')) {
        content = card.querySelector('.r9-cover-copy-layout');
        first = card.querySelector('.r9-cover-top-copy');
        last = card.querySelector('.r9-cover-bottom-title');
      } else if (card.classList.contains('r9-intro-meetup-card')) {
        content = card.querySelector('.r9-meetup-text');
        first = card.querySelector('.r9-meetup-copy-group');
        last = card.querySelector('.r9-meetup-cta');
      } else if (card.classList.contains('r9-action-card')) {
        content = card.querySelector('.r9-action-card-content');
        first = card.querySelector('.r9-action-card-top');
        last = card.querySelector('.r9-action-card-prize');
      }

      if (!content || !first || !last) return null;
      return { content: content, first: first, last: last };
    }

    function copyFitsCard(card) {
      var nodes = getCopyFitNodes(card);
      if (!nodes) return true;

      var contentRect = nodes.content.getBoundingClientRect();
      var firstRect = nodes.first.getBoundingClientRect();
      var lastRect = nodes.last.getBoundingClientRect();
      if (!contentRect.width || !contentRect.height) return true;

      return firstRect.top >= contentRect.top - 1
        && lastRect.bottom <= contentRect.bottom + 1
        && lastRect.top >= firstRect.bottom - 1;
    }

    function updateCopyFit() {
      cards.forEach(function (card) {
        card.classList.remove('r9-copy-dense', 'r9-copy-tight');
      });

      cards.forEach(function (card) {
        if (copyFitsCard(card)) return;
        card.classList.add('r9-copy-dense');
        if (!copyFitsCard(card)) card.classList.add('r9-copy-tight');
      });
    }

    function requestCopyFit() {
      if (copyFitFrame) return;
      copyFitFrame = window.requestAnimationFrame(function () {
        copyFitFrame = 0;
        if (!root.isConnected) return;
        updateCopyFit();
      });
    }

    function isMobileViewport() {
      return mobileViewport.matches;
    }

    function getClickEffectsLayer() {
      if (clickEffectsLayer) return clickEffectsLayer;
      clickEffectsLayer = document.createElement('div');
      clickEffectsLayer.className = 'r9-click-effects-layer';
      clickEffectsLayer.setAttribute('aria-hidden', 'true');
      root.appendChild(clickEffectsLayer);
      return clickEffectsLayer;
    }

    function trimClickEffectParticles(layer) {
      var overflow = layer.children.length - clickEffectConfig.maxActiveParticles;
      if (overflow <= 0) return;
      asArray(layer.children).slice(0, overflow).forEach(function (particle) {
        particle.remove();
      });
    }

    function spawnClickEffect(event) {
      if (reducedMotion.matches || (!event.clientX && !event.clientY)) return;
      var layer = getClickEffectsLayer();
      var baseDistance = clickEffectConfig.effectSize * 0.2;
      var randomDistance = clickEffectConfig.effectSize * 0.3;

      for (var index = 0; index < clickEffectConfig.particleCount; index += 1) {
        var angle = (index * 360) / clickEffectConfig.particleCount * (Math.PI / 180);
        var distance = baseDistance + Math.random() * randomDistance;
        var particle = document.createElement('span');
        particle.className = 'r9-click-effect-particle';
        particle.style.setProperty('--r9-click-x', event.clientX + 'px');
        particle.style.setProperty('--r9-click-y', event.clientY + 'px');
        particle.style.setProperty('--r9-click-dx', Math.cos(angle) * distance + 'px');
        particle.style.setProperty('--r9-click-dy', Math.sin(angle) * distance + 'px');
        particle.style.setProperty('--r9-click-duration', clickEffectConfig.duration + 'ms');
        particle.style.setProperty('--r9-click-particle-size', clickEffectConfig.particleSize + 'px');
        particle.style.setProperty('--r9-click-particle-color', clickEffectConfig.color);
        particle.addEventListener('animationend', function (animationEvent) {
          animationEvent.currentTarget.remove();
        }, { once: true });
        layer.appendChild(particle);
      }
      trimClickEffectParticles(layer);
    }

    function buildMobileNavRail(level, sources) {
      var rail = document.createElement('div');
      rail.className = 'r9-mobile-nav-status-rail';
      rail.setAttribute('data-r9-mobile-nav-rail', level);

      var items = sources.map(function (source) {
        var element = document.createElement('button');
        var icon = document.createElement('span');
        var itemLabel = document.createElement('span');
        var sourceImage = source.querySelector('img');
        var sourceFallback = source.querySelector('.r9-nav-fallback');
        var label = source.querySelector('.r9-nav-label');
        var labelText = source.getAttribute('data-r9-mobile-nav-label') || (label ? label.textContent.trim() : '');
        var target = source.getAttribute('data-r9-target') || source.getAttribute('href') || '';
        if (target.charAt(0) === '#') target = target.slice(1);

        element.className = 'r9-mobile-nav-status-item';
        element.type = 'button';
        element.setAttribute('data-r9-mobile-status-target', target);
        element.setAttribute('aria-label', labelText ? 'Go to ' + labelText : 'Go to anniversary chapter');
        icon.className = 'r9-mobile-nav-status-icon';
        itemLabel.className = 'r9-mobile-nav-status-item-label';
        itemLabel.textContent = labelText;
        if (sourceImage) {
          var image = document.createElement('img');
          image.src = sourceImage.getAttribute('src') || '';
          image.alt = '';
          icon.appendChild(image);
        } else if (sourceFallback) {
          var fallback = document.createElement('span');
          fallback.className = 'r9-mobile-nav-status-fallback';
          fallback.textContent = sourceFallback.textContent || '';
          icon.appendChild(fallback);
        }
        element.appendChild(icon);
        element.appendChild(itemLabel);
        rail.appendChild(element);
        return {
          section: source.getAttribute('data-r9-mobile-nav-section') || '',
          target: target || source.getAttribute('data-r9-mobile-nav-section') || '',
          label: labelText,
          element: element,
        };
      });

      mobileProgress.appendChild(rail);
      return { rail: rail, items: items };
    }

    function buildMobileNavStatus(activeGroup) {
      if (!mobileProgress) return;
      var nextLevel = isCraftimeNavSection(activeGroup) ? 'expanded' : 'primary';
      if (mobileNavItems.length && activeMobileNavLevel === nextLevel) return;
      while (mobileProgress.firstChild) mobileProgress.removeChild(mobileProgress.firstChild);

      var primarySources = asArray(root.querySelectorAll('[data-r9-mobile-nav-item][data-r9-mobile-nav-level="primary"]'));
      var craftimeSources = asArray(root.querySelectorAll('[data-r9-mobile-nav-item][data-r9-mobile-nav-level="craftime"]'));
      var clusterSources = primarySources.filter(function (source) {
        return source.matches('[data-r9-nav-cluster]');
      });
      var primaryChapterSources = primarySources.filter(function (source) {
        return !source.matches('[data-r9-nav-cluster]');
      });
      var orderedSources = primaryChapterSources.slice(0, 1);
      if (nextLevel === 'expanded') {
        orderedSources = orderedSources
          .concat(craftimeSources)
          .concat(primaryChapterSources.slice(1));
      } else {
        orderedSources = orderedSources
          .concat(clusterSources.slice(0, 1))
          .concat(primaryChapterSources.slice(1));
      }
      var chapters = buildMobileNavRail(nextLevel, orderedSources);

      mobileNavItems = chapters.items;
      activeMobileNavLevel = nextLevel;
      activeMobileNavSection = '';
      chapters.rail.classList.add('r9-is-current');
      window.requestAnimationFrame(updateMobileNavScrollHints);
    }

    function updateMobileNavScrollHints() {
      if (!mobileProgress) return;
      var maximumScroll = Math.max(mobileProgress.scrollWidth - mobileProgress.clientWidth, 0);
      mobileProgress.classList.toggle('r9-can-scroll-left', mobileProgress.scrollLeft > 2);
      mobileProgress.classList.toggle('r9-can-scroll-right', mobileProgress.scrollLeft < maximumScroll - 2);
    }

    function centerMobileNavItem(item) {
      if (!mobileProgress || !item || !item.element || !isMobileViewport()) return;
      window.requestAnimationFrame(function () {
        if (!root.isConnected) return;
        var maximumScroll = Math.max(mobileProgress.scrollWidth - mobileProgress.clientWidth, 0);
        var targetLeft = item.element.offsetLeft - (mobileProgress.clientWidth - item.element.offsetWidth) / 2;
        var left = clamp(targetLeft, 0, maximumScroll);
        if (typeof mobileProgress.scrollTo === 'function') {
          mobileProgress.scrollTo({
            left: left,
            behavior: reducedMotion.matches ? 'auto' : 'smooth',
          });
        } else {
          mobileProgress.scrollLeft = left;
        }
        window.requestAnimationFrame(updateMobileNavScrollHints);
      });
    }

    function updateMobileNavStatus(activeGroup, progressAngle) {
      if (!mobileProgress || !mobileLabel) return;
      buildMobileNavStatus(activeGroup);

      var activeSection = activeGroup;
      var activeMeta = navMeta.get(activeGroup);
      var firstCraftimeMeta = navMeta.get(craftimeNavSections[0]);
      var lastCraftimeMeta = navMeta.get(craftimeNavSections[craftimeNavSections.length - 1]);
      var activeIndex = mobileNavItems.findIndex(function (item) { return item.section === activeSection; });
      if (activeIndex < 0) activeIndex = 0;
      var didChangeSection = activeMobileNavSection !== activeSection;
      activeMobileNavSection = activeSection;

      mobileNavItems.forEach(function (item) {
        var itemMeta = navMeta.get(item.section);
        var itemRatio = 0;
        if (item.section === 'craftime' && activeMeta && firstCraftimeMeta && lastCraftimeMeta) {
          if (activeMeta.order > lastCraftimeMeta.order) {
            itemRatio = 1;
          } else if (activeMeta.order >= firstCraftimeMeta.order && activeMeta.order <= lastCraftimeMeta.order) {
            var craftimeIndex = Math.max(craftimeNavSections.indexOf(activeGroup), 0);
            itemRatio = clamp((craftimeIndex + progressAngle / 360) / craftimeNavSections.length, 0, 1);
          }
        } else if (itemMeta && activeMeta) {
          if (itemMeta.order < activeMeta.order) itemRatio = 1;
          if (itemMeta.order === activeMeta.order) itemRatio = clamp(progressAngle / 360, 0, 1);
        }

        var isActive = item.section === activeSection;
        item.element.classList.toggle('r9-is-active', isActive);
        item.element.classList.toggle('r9-is-progressed', itemRatio > 0);
        item.element.classList.toggle('r9-is-complete', itemRatio >= 1 && !isActive);
        if (isActive) item.element.setAttribute('aria-current', 'page');
        else item.element.removeAttribute('aria-current');
        item.element.style.setProperty(
          '--r9-mobile-nav-progress-angle',
          (itemRatio * 360).toFixed(3) + 'deg',
        );
      });

      if (didChangeSection) centerMobileNavItem(mobileNavItems[activeIndex]);
      else updateMobileNavScrollHints();
      mobileLabel.textContent = mobileNavItems[activeIndex] ? mobileNavItems[activeIndex].label : activeGroup;
    }

    function buildNavMeta() {
      var groupOrder = [];
      navItems.forEach(function (item) {
        var group = item.dataset.r9NavSection;
        if (group && groupOrder.indexOf(group) === -1) groupOrder.push(group);
      });

      var meta = new Map();
      groupOrder.forEach(function (group, order) {
        var groupCards = cards.filter(function (card) {
          return (card.dataset.r9NavSection || card.dataset.r9Section) === group;
        });
        meta.set(group, { order: order, cards: groupCards });
      });
      return meta;
    }

    function syncDeckHeight() {
      var height = Math.max(100, cards.length * 100);
      deck.style.setProperty('--r9-deck-height', height + 'svh');
      deck.style.height = height + 'svh';
      root.style.setProperty('--r9-deck-height', height + 'svh');
      deckMetrics = null;
    }

    function getMetrics() {
      if (deckMetrics) return deckMetrics;
      var rectangle = deck.getBoundingClientRect();
      var top = window.scrollY + rectangle.top;
      var range = Math.max(deck.offsetHeight - window.innerHeight, 1);
      deckMetrics = {
        top: top,
        end: top + range,
        range: range,
        step: cards.length > 1 ? range / (cards.length - 1) : range,
      };
      return deckMetrics;
    }

    function getProgress(metrics) {
      var progress = clamp((window.scrollY - metrics.top) / Math.max(metrics.step, 1), 0, cards.length - 1);
      return isMobileViewport() ? Math.round(progress) : progress;
    }

    function setCardAccessibility(card, isActive, canPoint) {
      var runtime = cardRuntimeByElement.get(card);
      if (!runtime) return;

      if (runtime.isActive !== isActive) {
        runtime.isActive = isActive;
        card.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        if (runtime.tabindex !== null) {
          if (isActive) card.setAttribute('tabindex', runtime.tabindex);
          else card.setAttribute('tabindex', '-1');
        }
        runtime.controls.forEach(function (controlState) {
          if (!isActive) {
            controlState.element.setAttribute('tabindex', '-1');
          } else if (controlState.tabindex === null) {
            controlState.element.removeAttribute('tabindex');
          } else {
            controlState.element.setAttribute('tabindex', controlState.tabindex);
          }
        });
      }

      if (runtime.canPoint !== canPoint) {
        runtime.canPoint = canPoint;
        card.style.pointerEvents = canPoint ? 'auto' : 'none';
      }
    }

    function applyCardPose(card, offset, mobile) {
      var absolute = Math.abs(offset);
      var sign = Math.sign(offset);
      var overflow = Math.max(absolute - 1, 0);
      var x = absolute <= 1 ? offset * 34 : sign * (34 + overflow * 17.5);
      var z = -Math.min(absolute, 1) * 136 - overflow * 163;
      var scale = clamp(1 - Math.min(absolute, 1) * 0.25 - overflow * 0.12, 0.42, 1);
      var widthScale = clamp(1 - overflow * 0.12, 0.72, 1);
      var rotateY = clamp(sign * (Math.min(absolute, 1) * 27 + overflow * 27), -54, 54);
      var opacity = absolute <= 1 ? 1 - absolute * 0.04 : clamp(0.96 - overflow * 2.4, 0, 0.96);
      var isIntroCover = card.dataset.r9Section === 'intro' && offset > -0.98;
      var mobileScale = mobile && !isIntroCover
        ? clamp(Math.min(window.innerWidth * 0.84 / 360, (window.innerHeight - 250) / 590), 0.58, 1)
        : 1;

      card.style.transform = [
        'translate(-50%, -50%)',
        'translateX(' + x.toFixed(3) + 'vw)',
        'translateZ(' + z.toFixed(3) + 'px)',
        'rotateY(' + rotateY.toFixed(3) + 'deg)',
        'scaleX(' + widthScale.toFixed(4) + ')',
        'scale(' + (scale * mobileScale).toFixed(4) + ')',
      ].join(' ');
      card.style.opacity = opacity.toFixed(3);
      card.style.zIndex = String(Math.round(1000 - absolute * 100));
      card.style.visibility = absolute > 1.45 ? 'hidden' : 'visible';
      var isActive = absolute < 0.5;
      var canPoint = isActive || (!mobile && absolute <= 1.05);
      var runtime = cardRuntimeByElement.get(card);
      if (runtime && runtime.isActive !== isActive) card.classList.toggle('r9-is-active', isActive);
      if (runtime && runtime.isIntroCoverMode !== isIntroCover) {
        runtime.isIntroCoverMode = isIntroCover;
        card.classList.toggle('r9-is-intro-cover-mode', isIntroCover);
      }
      setCardAccessibility(card, isActive, canPoint);
    }

    function parkCardPose(runtime) {
      var card = runtime.card;
      card.style.opacity = '0';
      card.style.zIndex = '0';
      card.style.visibility = 'hidden';
      if (runtime.isActive !== false) card.classList.remove('r9-is-active');
      if (runtime.isIntroCoverMode !== false) card.classList.remove('r9-is-intro-cover-mode');
      runtime.isIntroCoverMode = false;
      setCardAccessibility(card, false, false);
    }

    function updateCardPoses(progressValue) {
      var centerIndex = clamp(Math.round(progressValue), 0, cards.length - 1);
      var nextStart = Math.max(centerIndex - 2, 0);
      var nextEnd = Math.min(centerIndex + 2, cards.length - 1);
      var mobile = isMobileViewport();

      if (!cardPosesInitialized) {
        cardRuntime.forEach(parkCardPose);
        cardPosesInitialized = true;
      } else {
        for (var previousIndex = poseWindowStart; previousIndex <= poseWindowEnd; previousIndex += 1) {
          if (previousIndex < nextStart || previousIndex > nextEnd) {
            parkCardPose(cardRuntime[previousIndex]);
          }
        }
      }

      for (var index = nextStart; index <= nextEnd; index += 1) {
        applyCardPose(cards[index], index - progressValue, mobile);
      }
      poseWindowStart = nextStart;
      poseWindowEnd = nextEnd;
    }

    function resetCardPose(card) {
      var runtime = cardRuntimeByElement.get(card);
      ['transform', 'opacity', 'z-index', 'visibility', 'pointer-events'].forEach(function (property) {
        card.style.removeProperty(property);
      });
      card.classList.remove('r9-is-active', 'r9-is-intro-cover-mode');
      card.setAttribute('aria-hidden', 'false');
      if (!runtime) return;
      if (runtime.tabindex === null) card.removeAttribute('tabindex');
      else card.setAttribute('tabindex', runtime.tabindex);
      runtime.controls.forEach(function (controlState) {
        if (controlState.tabindex === null) controlState.element.removeAttribute('tabindex');
        else controlState.element.setAttribute('tabindex', controlState.tabindex);
      });
      runtime.isActive = null;
      runtime.canPoint = null;
      runtime.isIntroCoverMode = null;
    }

    function updateTheme(card) {
      if (!card) return;
      var previousSection = root.dataset.r9ActiveSection || '';
      var theme = card.dataset.r9Theme || 'black';
      var themeValues = themeConfig[theme] || themeConfig.black;
      themeClasses.forEach(function (name) {
        root.classList.remove(name);
      });
      root.classList.add('r9-theme-' + theme);
      root.classList.toggle('r9-theme-light-ui', card.dataset.r9Ui === 'light');
      root.classList.toggle('r9-theme-dark-ui', card.dataset.r9Ui !== 'light');

      var coverImage = card.dataset.r9CoverImage || '';
      var safeImage = coverImage.replace(/[\n\r]/g, '').trim();
      var isCover = Boolean(card.dataset.r9Cover === 'true' && safeImage);
      var isIntro = card.dataset.r9Section === 'intro';
      stage.style.setProperty('--r9-chapter-bg', themeValues.bg);
      stage.style.setProperty('--r9-chapter-ink', themeValues.ink);
      stage.style.setProperty('--r9-grid-line', themeValues.grid);
      stage.style.setProperty('--r9-cover-image', safeImage ? 'url(' + JSON.stringify(safeImage) + ')' : 'none');
      stage.style.setProperty('--r9-cover-size', 'cover');
      stage.style.setProperty('--r9-cover-bleed-x', '0px');
      stage.style.setProperty('--r9-cover-bleed-y', '0px');
      stage.classList.toggle('r9-is-cover-stage', isCover);
      stage.classList.toggle('r9-is-intro-cover-stage', isIntro);
      stage.classList.toggle('r9-is-section-cover-stage', isCover && !isIntro);
      root.dataset.r9ActiveSection = card.dataset.r9Section || '';
      if (previousSection === 'intro' && !isIntro) resetIntroMouseFollow();
    }

    function shouldCollapseCraftimeNav(activeGroup) {
      if (root.classList.contains('r9-mobile-nav-open')) {
        return !clusterToggle || clusterToggle.getAttribute('aria-expanded') !== 'true';
      }
      return !isCraftimeNavSection(activeGroup);
    }

    function updateNavigation(card, progressValue, activeChanged) {
      if (!card) return;
      var shouldUpdateState = activeChanged !== false;
      var runtime = cardRuntimeByElement.get(card);
      var activeGroup = runtime ? runtime.navGroup : (card.dataset.r9NavSection || card.dataset.r9Section);
      var activeMeta = navMeta.get(activeGroup);
      var groupCards = activeMeta ? activeMeta.cards : [];
      var localIndex = runtime ? runtime.navLocalIndex : Math.max(groupCards.indexOf(card), 0);
      var cardIndex = runtime ? runtime.index : cards.indexOf(card);
      var localOffset = clamp(progressValue - cardIndex, -0.49, 0.49);
      var ratio = groupCards.length ? clamp((localIndex + 1 + localOffset) / groupCards.length, 1 / groupCards.length, 1) : 1;

      navItems.forEach(function (item) {
        var meta = navMeta.get(item.dataset.r9NavSection);
        var itemRatio = 0;
        if (meta && activeMeta) {
          if (meta.order < activeMeta.order) itemRatio = 1;
          if (meta.order === activeMeta.order) itemRatio = ratio;
        }
        item.style.setProperty('--r9-nav-progress-angle', (itemRatio * 360).toFixed(2) + 'deg');
        item.classList.toggle('r9-is-progressed', itemRatio > 0);
        item.classList.toggle('r9-is-complete', itemRatio >= 1 && meta && activeMeta && meta.order < activeMeta.order);
        if (shouldUpdateState) {
          item.classList.toggle('r9-is-active', item.dataset.r9NavSection === activeGroup);
        }
      });

      if (clusterToggle) {
        var firstCraftimeMeta = navMeta.get(craftimeNavSections[0]);
        var lastCraftimeMeta = navMeta.get(craftimeNavSections[craftimeNavSections.length - 1]);
        var clusterRatio = 0;
        if (activeMeta && firstCraftimeMeta && lastCraftimeMeta) {
          if (activeMeta.order > lastCraftimeMeta.order) {
            clusterRatio = 1;
          } else if (activeMeta.order >= firstCraftimeMeta.order && activeMeta.order <= lastCraftimeMeta.order) {
            var craftimeIndex = Math.max(craftimeNavSections.indexOf(activeGroup), 0);
            clusterRatio = clamp((craftimeIndex + ratio) / craftimeNavSections.length, 0, 1);
          }
        }
        clusterToggle.style.setProperty('--r9-nav-cluster-progress-angle', (clusterRatio * 360).toFixed(2) + 'deg');
        clusterToggle.classList.toggle('r9-is-progressed', clusterRatio > 0);
        clusterToggle.classList.toggle('r9-is-complete', clusterRatio >= 1);
        if (shouldUpdateState) {
          clusterToggle.classList.toggle('r9-is-active', isCraftimeNavSection(activeGroup));
        }
      }

      if (shouldUpdateState) {
        var shouldCollapseCluster = shouldCollapseCraftimeNav(activeGroup);
        if (chapterNav) chapterNav.classList.toggle('r9-is-craftime-collapsed', shouldCollapseCluster);
        if (clusterToggle && !root.classList.contains('r9-mobile-nav-open')) {
          clusterToggle.setAttribute('aria-expanded', String(!shouldCollapseCluster));
        }
        if (isMobileViewport()) updateMobileNavStatus(activeGroup, ratio * 360);
      }
    }

    function syncMobileSharePosition(activeCard) {
      if (!startButton || !isMobileViewport()) {
        if (startButton) startButton.style.removeProperty('--r9-mobile-share-bottom');
        return;
      }

      var cardRectangle = activeCard ? activeCard.getBoundingClientRect() : null;
      var footerRectangle = footer ? footer.getBoundingClientRect() : null;
      var buttonRectangle = startButton.getBoundingClientRect();
      if (
        !cardRectangle ||
        !footerRectangle ||
        !buttonRectangle.height ||
        cardRectangle.bottom >= footerRectangle.top - 18
      ) {
        startButton.style.removeProperty('--r9-mobile-share-bottom');
        return;
      }

      var gapCenter = cardRectangle.bottom + (footerRectangle.top - cardRectangle.bottom) * 0.5;
      var bottom = clamp(
        window.innerHeight - gapCenter - buttonRectangle.height * 0.5,
        44,
        window.innerHeight * 0.24,
      );
      startButton.style.setProperty('--r9-mobile-share-bottom', bottom.toFixed(2) + 'px');
    }

    function updateStartButton() {
      if (!startButton) return;
      startButton.textContent = activeIndex >= cards.length - 1 ? 'BACK TO START' : defaultStartLabel;
      startButton.hidden = isMobileViewport() && activeIndex !== 0;
    }

    function updateCoverStepControls(card) {
      if (!coverControls) return;
      var isSectionCover = Boolean(
        card &&
        card.dataset.r9Cover === 'true' &&
        card.dataset.r9Section !== 'intro' &&
        !root.classList.contains('r9-is-static')
      );
      coverControls.hidden = !isSectionCover;
      if (!isSectionCover) return;

      coverStepRuntime.forEach(function (step) {
        var button = step.button;
        var direction = step.direction;
        var targetIndex = activeIndex + direction;
        var targetCard = cards[targetIndex];
        var isUnavailable = !targetCard || !direction;
        button.disabled = isUnavailable;
        button.setAttribute(
          'aria-label',
          isUnavailable
            ? step.label
            : step.label + ': ' + (targetCard.getAttribute('aria-label') || 'story item ' + (targetIndex + 1)),
        );
      });
    }

    function releaseFocusFromInactiveCard(previousCard) {
      var focusedElement = document.activeElement;
      if (!previousCard || !focusedElement || !previousCard.contains(focusedElement)) return;
      if (focusedElement.blur) focusedElement.blur();
    }

    function updateDeck() {
      frame = 0;
      if (!root.isConnected || root.classList.contains('r9-is-static') || !visible) return;

      var metrics = getMetrics();
      currentProgress = getProgress(metrics);
      var nextActiveIndex = clamp(Math.round(currentProgress), 0, cards.length - 1);
      var activeChanged = nextActiveIndex !== renderedActiveIndex;
      var previousActiveCard = renderedActiveIndex >= 0 ? cards[renderedActiveIndex] : null;
      activeIndex = nextActiveIndex;
      var activeCard = cards[activeIndex];

      if (activeChanged && activeCityDialog && !activeCard.contains(activeCityDialog)) closeCityDialog(false);

      updateCardPoses(currentProgress);
      if (!isMobileViewport() || activeChanged) {
        updateNavigation(activeCard, currentProgress, activeChanged);
      }
      if (activeChanged) {
        updateTheme(activeCard);
        updateStartButton();
        updateCoverStepControls(activeCard);
        syncMobileSharePosition(activeCard);
        releaseFocusFromInactiveCard(previousActiveCard);
        renderedActiveIndex = activeIndex;
      }

      if (programmaticScrollInProgress && Math.abs(currentProgress - programmaticTargetIndex) <= 0.001) {
        programmaticScrollInProgress = false;
        programmaticTargetIndex = -1;
        wheelScrollTargetIndex = -1;
      } else if (wheelScrollTargetIndex >= 0 && Math.abs(currentProgress - wheelScrollTargetIndex) <= 0.001) {
        wheelScrollTargetIndex = -1;
      }
    }

    function requestUpdate() {
      if (frame || root.classList.contains('r9-is-static')) return;
      frame = window.requestAnimationFrame(updateDeck);
    }

    function scrollToIndex(index, behavior, preserveWheelGesture) {
      var targetIndex = clamp(index, 0, cards.length - 1);
      if (!preserveWheelGesture) {
        resetWheelGesture();
        wheelScrollTargetIndex = -1;
      }
      var metrics = getMetrics();
      var top = metrics.top + metrics.step * targetIndex;
      var resolvedBehavior = isMobileViewport() ? 'auto' : (behavior || 'smooth');
      programmaticScrollInProgress = resolvedBehavior === 'smooth';
      programmaticTargetIndex = programmaticScrollInProgress ? targetIndex : -1;
      window.scrollTo({ top: top, behavior: resolvedBehavior });
      requestUpdate();
    }

    function navigateToStoryCard(index) {
      var targetIndex = clamp(index, 0, cards.length - 1);
      var targetCard = cards[targetIndex];
      if (!targetCard || targetIndex === activeIndex) return false;

      if (root.classList.contains('r9-is-static')) {
        targetCard.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
      } else {
        scrollToIndex(targetIndex, reducedMotion.matches ? 'auto' : 'smooth');
      }
      if (liveRegion) {
        liveRegion.textContent = 'Showing anniversary story card ' + (targetIndex + 1) + ' of ' + cards.length + '.';
      }
      return true;
    }

    function scrollToSection(sectionKey, behavior) {
      var index = cards.findIndex(function (card) {
        return card.dataset.r9Section === sectionKey;
      });
      if (index < 0) return;
      scrollToIndex(index, behavior);
      try {
        if (window.location.hash !== '#' + sectionKey) window.history.replaceState(null, '', '#' + sectionKey);
      } catch (error) {
        // History updates are optional in restricted preview frames.
      }
    }

    function resetSwipePointer() {
      swipePointer = null;
    }

    function resetMobileNavSwipePointer() {
      mobileNavSwipePointer = null;
    }

    function closeMobileNavigation(restoreFocus) {
      var wasOpen = root.classList.contains('r9-mobile-nav-open');
      root.classList.remove('r9-mobile-nav-open');
      resetMobileNavSwipePointer();
      if (mobileToggle) {
        mobileToggle.setAttribute('aria-expanded', 'false');
        mobileToggle.setAttribute('aria-label', 'Open anniversary navigation');
      }
      syncInteractionIsolation();
      syncWheelBlocker();
      if (mobileToggle && wasOpen && restoreFocus) mobileToggle.focus({ preventScroll: true });
      else if (wasOpen && chapterNav && chapterNav.contains(document.activeElement) && document.activeElement.blur) {
        document.activeElement.blur();
      }
      return wasOpen;
    }

    function handleMobileNavPointerDown(event) {
      if (
        !isMobileViewport() ||
        root.classList.contains('r9-mobile-nav-open') ||
        root.classList.contains('r9-is-static') ||
        (event.pointerType === 'mouse' && typeof event.button === 'number' && event.button !== 0)
      ) {
        resetMobileNavSwipePointer();
        return;
      }
      mobileNavSwipePointer = { id: event.pointerId, x: event.clientX, y: event.clientY };
    }

    function handleMobileNavPointerUp(event) {
      if (!mobileNavSwipePointer || event.pointerId !== mobileNavSwipePointer.id) return;
      var deltaX = event.clientX - mobileNavSwipePointer.x;
      var deltaY = event.clientY - mobileNavSwipePointer.y;
      resetMobileNavSwipePointer();
      if (Math.abs(deltaX) >= 12 && Math.abs(deltaX) > Math.abs(deltaY) * 1.15) {
        suppressSwipeClickOnce();
      }
      updateMobileNavScrollHints();
    }

    function handleSwipePointerDown(event) {
      if (
        event.pointerType !== 'touch' ||
        !isMobileViewport() ||
        root.classList.contains('r9-mobile-nav-open') ||
        root.classList.contains('r9-is-static') ||
        (event.target && event.target.closest && event.target.closest('[data-r9-city-dialog]'))
      ) {
        resetSwipePointer();
        return;
      }
      swipePointer = { id: event.pointerId, x: event.clientX, y: event.clientY, index: activeIndex };
    }

    function suppressSwipeClickOnce() {
      suppressNextClick = true;
      clearTrackedTimeout(suppressClickTimer);
      suppressClickTimer = addTimeout(function () {
        suppressNextClick = false;
        suppressClickTimer = 0;
      }, swipeConfig.clickSuppressMs);
    }

    function handleSwipePointerUp(event) {
      if (root.classList.contains('r9-mobile-nav-open')) {
        resetSwipePointer();
        return;
      }
      if (!swipePointer || event.pointerId !== swipePointer.id) return;
      var deltaX = event.clientX - swipePointer.x;
      var deltaY = event.clientY - swipePointer.y;
      var startIndex = swipePointer.index;
      resetSwipePointer();

      var absoluteX = Math.abs(deltaX);
      var absoluteY = Math.abs(deltaY);
      var direction = 0;

      if (
        absoluteX >= swipeConfig.minimumDistance &&
        absoluteX > absoluteY * swipeConfig.axisRatio
      ) {
        direction = deltaX < 0 ? 1 : -1;
      } else if (
        absoluteY >= swipeConfig.minimumDistance &&
        absoluteY > absoluteX * swipeConfig.axisRatio
      ) {
        direction = deltaY < 0 ? 1 : -1;
      }

      if (!direction) return;
      suppressSwipeClickOnce();
      navigateToStoryCard(startIndex + direction);
    }

    function handleRootClick(event) {
      if (suppressNextClick) {
        suppressNextClick = false;
        clearTrackedTimeout(suppressClickTimer);
        suppressClickTimer = 0;
        event.preventDefault();
        return;
      }

      var mobileButton = event.target.closest('[data-r9-mobile-toggle]');
      if (mobileButton && root.contains(mobileButton)) {
        var shouldOpen = !root.classList.contains('r9-mobile-nav-open');
        if (shouldOpen && activeCityDialog) closeCityDialog(false);
        if (shouldOpen) {
          root.classList.add('r9-mobile-nav-open');
          resetWheelGesture();
          cancelProgrammaticScrollForUserInput();
          resetSwipePointer();
          resetMobileNavSwipePointer();
          if (clusterToggle) clusterToggle.setAttribute('aria-expanded', 'false');
          if (chapterNav) chapterNav.classList.add('r9-is-craftime-collapsed');
          mobileButton.setAttribute('aria-expanded', 'true');
          mobileButton.setAttribute('aria-label', 'Close anniversary navigation');
          syncInteractionIsolation();
          syncWheelBlocker();
          addTimeout(focusFirstMobileMenuItem, 0);
        } else {
          closeMobileNavigation(false);
        }
        return;
      }

      if (
        isMobileViewport() &&
        root.classList.contains('r9-mobile-nav-open') &&
        !event.target.closest('.r9-nav-item, [data-r9-nav-cluster], .r9-header-action, .r9-mobile-home')
      ) {
        event.preventDefault();
        closeMobileNavigation(true);
        return;
      }

      var mobileStatusButton = event.target.closest('[data-r9-mobile-status-target]');
      if (mobileStatusButton && root.contains(mobileStatusButton)) {
        var mobileStatusTarget = mobileStatusButton.dataset.r9MobileStatusTarget;
        if (!mobileStatusTarget) return;
        event.preventDefault();
        scrollToSection(mobileStatusTarget, reducedMotion.matches ? 'auto' : 'smooth');
        return;
      }

      var cityClose = event.target.closest('[data-r9-city-close]');
      if (cityClose && root.contains(cityClose)) {
        event.preventDefault();
        closeCityDialog(true);
        return;
      }

      var cityOpen = event.target.closest('[data-r9-city-open]');
      if (cityOpen && root.contains(cityOpen)) {
        event.preventDefault();
        var cityOpenCard = cityOpen.closest('[data-r9-card]');
        var cityOpenIndex = cards.indexOf(cityOpenCard);
        if (
          !root.classList.contains('r9-is-static') &&
          cityOpenIndex >= 0 &&
          cityOpenIndex !== activeIndex
        ) {
          navigateToStoryCard(cityOpenIndex);
          return;
        }
        openCityDialog(cityOpen);
        return;
      }

      if (activeCityDialog && event.target === activeCityDialog) {
        event.preventDefault();
        closeCityDialog(true);
        return;
      }

      if (activeCityDialog && !activeCityDialog.contains(event.target)) {
        event.preventDefault();
        return;
      }

      var clusterButton = event.target.closest('[data-r9-nav-cluster]');
      if (clusterButton && root.contains(clusterButton)) {
        event.preventDefault();
        var clusterTarget = clusterButton.dataset.r9Target || 'creator-business';
        clusterButton.setAttribute('aria-expanded', 'true');
        if (chapterNav) chapterNav.classList.remove('r9-is-craftime-collapsed');
        closeMobileNavigation(true);
        if (root.classList.contains('r9-is-static')) {
          var clusterTargetCard = cards.find(function (card) { return card.dataset.r9Section === clusterTarget; });
          if (clusterTargetCard) clusterTargetCard.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
        } else {
          scrollToSection(clusterTarget, reducedMotion.matches ? 'auto' : 'smooth');
        }
        return;
      }

      var coverStepButton = event.target.closest('[data-r9-cover-step]');
      if (coverStepButton && root.contains(coverStepButton)) {
        event.preventDefault();
        var direction = Number(coverStepButton.dataset.r9CoverStep);
        var targetIndex = clamp(activeIndex + direction, 0, cards.length - 1);
        if (direction) navigateToStoryCard(targetIndex);
        return;
      }

      var scrollLink = event.target.closest('[data-r9-scroll-link]');
      if (scrollLink && root.contains(scrollLink)) {
        var target = scrollLink.dataset.r9Target;
        if (!target) return;
        event.preventDefault();
        closeMobileNavigation(true);
        if (root.classList.contains('r9-is-static')) {
          var targetCard = cards.find(function (card) { return card.dataset.r9Section === target; });
          if (targetCard) targetCard.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
        } else {
          scrollToSection(target, reducedMotion.matches ? 'auto' : 'smooth');
        }
        return;
      }

      var clickedStage = event.target.closest('[data-r9-stage]');
      var activeCard = cards[activeIndex];
      var isIntroCover = activeCard && activeCard.dataset.r9Section === 'intro';
      var isSectionCover = activeCard && activeCard.dataset.r9Cover === 'true';
      var isInteractiveTarget = event.target.closest('a, button, input, select, textarea, label, [role="button"]');
      if (
        clickedStage &&
        root.contains(clickedStage) &&
        activeCard &&
        (isIntroCover || isSectionCover) &&
        !isInteractiveTarget &&
        !activeCityDialog &&
        !isMobileViewport() &&
        finePointer.matches &&
        !root.classList.contains('r9-is-static') &&
        !root.classList.contains('r9-mobile-nav-open')
      ) {
        var coverDirection = 1;
        if (isSectionCover) {
          var activeCardRectangle = activeCard.getBoundingClientRect();
          coverDirection = event.clientX < activeCardRectangle.left + activeCardRectangle.width * 0.5 ? -1 : 1;
        }
        if (navigateToStoryCard(activeIndex + coverDirection)) event.preventDefault();
        return;
      }

      var clickedCard = event.target.closest('[data-r9-card]');
      if (
        clickedCard &&
        root.contains(clickedCard) &&
        !isMobileViewport() &&
        !root.classList.contains('r9-is-static') &&
        !clickedCard.classList.contains('r9-is-active')
      ) {
        var clickedIndex = cards.indexOf(clickedCard);
        if (clickedIndex >= 0) {
          event.preventDefault();
          scrollToIndex(clickedIndex, 'smooth');
          return;
        }
      }

      var linkedCard = event.target.closest('[data-r9-card-link]');
      if (!linkedCard || !root.contains(linkedCard) || event.target.closest('a, button, input, select, textarea')) return;
      var destination = linkedCard.dataset.r9CardLink;
      var target = linkedCard.dataset.r9CardTarget || '_blank';
      if (!destination) return;
      if (target === '_self') window.location.assign(destination);
      else window.open(destination, '_blank', 'noopener,noreferrer');
    }

    function handleRootKeydown(event) {
      if (handleCityDialogKeydown(event)) return;
      if (root.classList.contains('r9-mobile-nav-open')) {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeMobileNavigation(true);
          return;
        }
        if (trapMobileMenuFocus(event)) return;
      }
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var linkedCard = event.target.closest('[data-r9-card-link]');
      if (!linkedCard || !root.contains(linkedCard) || event.target.closest('a, button, input, select, textarea')) return;
      var destination = linkedCard.dataset.r9CardLink;
      if (!destination) return;
      event.preventDefault();
      var target = linkedCard.dataset.r9CardTarget || '_blank';
      if (target === '_self') window.location.assign(destination);
      else window.open(destination, '_blank', 'noopener,noreferrer');
    }

    function handleCardNavigationKeydown(event) {
      if (
        event.defaultPrevented ||
        event.altKey ||
        event.ctrlKey ||
        event.metaKey ||
        root.classList.contains('r9-is-static') ||
        root.classList.contains('r9-mobile-nav-open') ||
        activeCityDialog
      ) return;

      var target = event.target;
      if (target && target.closest && target.closest('a, button, input, select, textarea, [contenteditable="true"]')) return;

      var targetIndex = activeIndex;
      if (event.key === 'ArrowDown' || event.key === 'ArrowRight' || event.key === 'PageDown' || (event.key === ' ' && !event.shiftKey)) {
        targetIndex += 1;
      } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft' || event.key === 'PageUp' || (event.key === ' ' && event.shiftKey)) {
        targetIndex -= 1;
      } else if (event.key === 'Home') {
        targetIndex = 0;
      } else if (event.key === 'End') {
        targetIndex = cards.length - 1;
      } else {
        return;
      }

      var metrics = getMetrics();
      if (window.scrollY < metrics.top - 4 || window.scrollY > metrics.end + 4) return;
      targetIndex = clamp(targetIndex, 0, cards.length - 1);
      if (targetIndex === activeIndex) return;
      event.preventDefault();
      navigateToStoryCard(targetIndex);
    }

    function getCityDialogFocusables(dialog) {
      return asArray(dialog.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])',
      )).filter(function (element) {
        return element.type !== 'hidden' && !element.hidden && element.getAttribute('aria-hidden') !== 'true';
      });
    }

    function focusWithoutPageScroll(element) {
      if (!element || !element.focus) return;
      var scrollX = window.scrollX || 0;
      var scrollY = window.scrollY || 0;
      function restoreScrollPosition() {
        if ((window.scrollX || 0) !== scrollX || (window.scrollY || 0) !== scrollY) {
          window.scrollTo({ left: scrollX, top: scrollY, behavior: 'auto' });
        }
      }
      element.focus({ preventScroll: true });
      restoreScrollPosition();
      window.requestAnimationFrame(function () {
        restoreScrollPosition();
        window.requestAnimationFrame(restoreScrollPosition);
      });
    }

    function restoreInteractionIsolation() {
      interactionIsolation.splice(0).forEach(function (state) {
        if (!state.element) return;
        if (state.hadInert) state.element.setAttribute('inert', '');
        else state.element.removeAttribute('inert');
      });
    }

    function isolateInteractionTo(allowedElement) {
      restoreInteractionIsolation();
      if (!allowedElement || !root.contains(allowedElement)) return;

      var branch = allowedElement;
      while (branch && branch !== root) {
        var parent = branch.parentElement;
        if (!parent) break;
        asArray(parent.children).forEach(function (sibling) {
          if (
            sibling === branch ||
            sibling.matches('[data-r9-live]') ||
            interactionIsolation.some(function (state) { return state.element === sibling; })
          ) return;
          interactionIsolation.push({ element: sibling, hadInert: sibling.hasAttribute('inert') });
          sibling.setAttribute('inert', '');
        });
        branch = parent;
      }
    }

    function syncInteractionIsolation() {
      if (activeCityDialog) {
        isolateInteractionTo(activeCityDialog);
        return;
      }
      if (root.classList.contains('r9-mobile-nav-open')) {
        isolateInteractionTo(root.querySelector('.r9-site-header'));
        return;
      }
      restoreInteractionIsolation();
    }

    function getMobileMenuFocusables() {
      var header = root.querySelector('.r9-site-header');
      if (!header) return [];
      return asArray(header.querySelectorAll(
        'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])',
      )).filter(function (element) {
        return !element.hidden && element.getAttribute('aria-hidden') !== 'true' && element.getClientRects().length;
      });
    }

    function focusFirstMobileMenuItem() {
      if (!root.classList.contains('r9-mobile-nav-open')) return;
      var focusables = getMobileMenuFocusables();
      var firstNavItem = focusables.find(function (element) {
        return element.matches('.r9-nav-item, [data-r9-nav-cluster]');
      });
      focusWithoutPageScroll(firstNavItem || focusables[0]);
    }

    function trapMobileMenuFocus(event) {
      if (event.key !== 'Tab') return false;
      var focusables = getMobileMenuFocusables();
      if (!focusables.length) {
        event.preventDefault();
        return true;
      }
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        focusWithoutPageScroll(last);
        return true;
      }
      if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        focusWithoutPageScroll(first);
        return true;
      }
      if (!focusables.includes(document.activeElement)) {
        event.preventDefault();
        focusWithoutPageScroll(event.shiftKey ? last : first);
        return true;
      }
      return false;
    }

    function normalizeCityName(value) {
      return String(value || '').replace(/\s+/g, ' ').trim().slice(0, 80);
    }

    function readCityStorage(key) {
      try {
        return window.localStorage.getItem(key) || '';
      } catch (error) {
        return '';
      }
    }

    function writeCityStorage(key, value) {
      try {
        if (value) window.localStorage.setItem(key, value);
        else window.localStorage.removeItem(key);
      } catch (error) {
        // The city submission still works when browser storage is unavailable.
      }
    }

    function getCityDeviceId() {
      var storedDeviceId = normalizeCityName(readCityStorage(cityDeviceStorageKey));
      if (storedDeviceId) return storedDeviceId;

      var randomPart = '';
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        randomPart = window.crypto.randomUUID();
      } else {
        randomPart = Math.random().toString(36).slice(2) + Date.now().toString(36);
      }

      var deviceId = 'r9_' + randomPart;
      writeCityStorage(cityDeviceStorageKey, deviceId);
      return deviceId;
    }

    function parseCitySubmission(value) {
      if (!value) return null;
      try {
        var submission = JSON.parse(value);
        var cityName = normalizeCityName(submission.city);
        var expiresAt = Date.parse(submission.expires_at);
        if (!cityName || !Number.isFinite(expiresAt) || expiresAt <= Date.now()) {
          writeCityStorage(citySubmissionStorageKey, '');
          return null;
        }
        return {
          city: cityName,
          submitted_at: submission.submitted_at || '',
          expires_at: new Date(expiresAt).toISOString(),
        };
      } catch (error) {
        writeCityStorage(citySubmissionStorageKey, '');
        return null;
      }
    }

    function getStoredCitySubmission() {
      return parseCitySubmission(readCityStorage(citySubmissionStorageKey));
    }

    function storeCitySubmission(cityName, responseData) {
      var normalizedCity = normalizeCityName(cityName);
      if (!normalizedCity) return null;

      var data = responseData || {};
      var submittedAt = Date.parse(data.submitted_at);
      if (!Number.isFinite(submittedAt)) submittedAt = Date.now();

      var expiresAt = Date.parse(data.expires_at);
      if (!Number.isFinite(expiresAt) && Number(data.retry_after) > 0) {
        expiresAt = Date.now() + Number(data.retry_after) * 1000;
      }
      if (!Number.isFinite(expiresAt) || expiresAt <= Date.now()) {
        expiresAt = submittedAt + citySubmissionWindow;
      }

      var submission = {
        city: normalizedCity,
        submitted_at: new Date(submittedAt).toISOString(),
        expires_at: new Date(expiresAt).toISOString(),
      };
      writeCityStorage(citySubmissionStorageKey, JSON.stringify(submission));
      return submission;
    }

    function renderSubmittedCity(cityName) {
      var normalizedCity = normalizeCityName(cityName);
      if (!normalizedCity) return;

      var cityCard = root.querySelector('.r9-preview-calendar-card');
      var submittedCity = cityCard && cityCard.querySelector('[data-r9-submitted-city]');
      var submittedCityLabel = submittedCity && submittedCity.querySelector('.r9-preview-calendar-city-label');
      var existingCities = cityCard ? asArray(cityCard.querySelectorAll('[data-r9-city-name]')) : [];
      var cityKey = normalizedCity.toLocaleLowerCase();
      var matchingCity = existingCities.find(function (city) {
        return normalizeCityName(city.dataset.r9CityName).toLocaleLowerCase() === cityKey;
      });

      existingCities.forEach(function (city) {
        city.classList.remove('r9-is-user-city', 'animate');
      });

      if (matchingCity) {
        if (submittedCity) submittedCity.hidden = true;
        matchingCity.classList.add('r9-is-user-city');
        void matchingCity.offsetWidth;
        window.requestAnimationFrame(function () {
          matchingCity.classList.add('animate');
        });
      } else if (submittedCity && submittedCityLabel) {
        submittedCityLabel.textContent = normalizedCity;
        submittedCity.hidden = false;
        submittedCity.style.animation = 'none';
        void submittedCity.offsetWidth;
        submittedCity.style.removeProperty('animation');
      }

      confirmedCityName = normalizedCity;
    }

    function resetCityStatus(dialog) {
      var status = dialog && dialog.querySelector('[data-r9-city-status]');
      var input = dialog && dialog.querySelector('.r9-preview-calendar-input');
      if (dialog) dialog.classList.remove('r9-is-submitted');
      if (input) input.disabled = false;
      if (status) {
        status.textContent = '';
        status.classList.remove('r9-is-error', 'r9-is-success', 'r9-is-duplicate');
      }
    }

    function showCityResult(dialog, resultType, cityName, message) {
      var status = dialog && dialog.querySelector('[data-r9-city-status]');
      var input = dialog && dialog.querySelector('.r9-preview-calendar-input');
      var normalizedCity = normalizeCityName(cityName);
      if (!dialog || !status) return;

      dialog.classList.add('r9-is-submitted');
      status.textContent = message;
      status.classList.remove('r9-is-error', 'r9-is-success', 'r9-is-duplicate');
      status.classList.add(resultType === 'duplicate' ? 'r9-is-duplicate' : 'r9-is-success');
      if (input) input.disabled = true;
      if (normalizedCity) {
        confirmedCityName = normalizedCity;
        if (activeCityDialog !== dialog) {
          renderSubmittedCity(normalizedCity);
          if (liveRegion) {
            liveRegion.textContent = 'Your city, ' + normalizedCity + ', is now shown on the card.';
          }
        }
      }
    }

    function openCityDialog(trigger, preserveStatus) {
      var card = trigger.closest('.r9-preview-calendar-card');
      var dialog = card && card.querySelector('[data-r9-city-dialog]');
      if (!dialog) return;

      if (activeCityDialog && activeCityDialog !== dialog) closeCityDialog(false);
      clearTrackedTimeout(cityDialogHideTimer);
      clearTrackedTimeout(cityFocusTimer);
      cityDialogHideTimer = 0;
      cityFocusTimer = 0;
      activeCityDialog = dialog;
      activeCityTrigger = trigger;
      resetWheelGesture();
      cancelProgrammaticScrollForUserInput();
      dialog.hidden = false;
      dialog.removeAttribute('inert');
      dialog.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      card.classList.add('r9-is-response-open');
      syncInteractionIsolation();
      syncWheelBlocker();
      if (!preserveStatus) {
        var storedSubmission = getStoredCitySubmission();
        if (storedSubmission) {
          showCityResult(
            dialog,
            'duplicate',
            storedSubmission.city,
            dialog.dataset.r9CityDuplicate || "You've already submitted a city in the last 24 hours.",
          );
        } else {
          resetCityStatus(dialog);
        }
      }

      cityFocusTimer = addTimeout(function () {
        cityFocusTimer = 0;
        var firstField = dialog.classList.contains('r9-is-submitted')
          ? dialog.querySelector('[data-r9-city-close]')
          : dialog.querySelector('.r9-preview-calendar-input');
        if (firstField && activeCityDialog === dialog) focusWithoutPageScroll(firstField);
      }, reducedMotion.matches ? 0 : 80);
    }

    function closeCityDialog(restoreFocus) {
      if (!activeCityDialog) return;
      var dialog = activeCityDialog;
      var trigger = activeCityTrigger;
      var card = dialog.closest('.r9-preview-calendar-card');
      var form = dialog.querySelector('.r9-preview-calendar-form');
      var submit = dialog.querySelector('[data-r9-city-submit]');
      var wasSubmitted = dialog.classList.contains('r9-is-submitted');
      var cityToReveal = wasSubmitted ? confirmedCityName : '';

      clearTrackedTimeout(cityFocusTimer);
      clearTrackedTimeout(cityDialogHideTimer);
      cityFocusTimer = 0;
      cityDialogHideTimer = 0;
      if (form) form.removeAttribute('aria-busy');
      if (submit) submit.disabled = false;
      if (card) card.classList.remove('r9-is-response-open');
      dialog.setAttribute('aria-hidden', 'true');
      dialog.setAttribute('inert', '');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      activeCityDialog = null;
      activeCityTrigger = null;
      syncInteractionIsolation();
      syncWheelBlocker();

      cityDialogHideTimer = addTimeout(function () {
        cityDialogHideTimer = 0;
        dialog.hidden = true;
        if (cityToReveal) {
          renderSubmittedCity(cityToReveal);
          if (restoreFocus && liveRegion) {
            liveRegion.textContent = 'Your city, ' + cityToReveal + ', is now shown on the card.';
          }
        }
      }, reducedMotion.matches ? 0 : 280);

      if (restoreFocus && trigger && trigger.isConnected) focusWithoutPageScroll(trigger);
    }

    function handleCityDialogKeydown(event) {
      if (!activeCityDialog) return false;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeCityDialog(true);
        return true;
      }
      if (event.key !== 'Tab') return false;

      var focusables = getCityDialogFocusables(activeCityDialog);
      if (!focusables.length) {
        event.preventDefault();
        return true;
      }
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        focusWithoutPageScroll(last);
        return true;
      }
      if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        focusWithoutPageScroll(first);
        return true;
      }
      return false;
    }

    function setCitySubmitState(form, submitting) {
      var submit = form.querySelector('[data-r9-city-submit]');
      form.setAttribute('aria-busy', String(submitting));
      if (submit) submit.disabled = submitting;
    }

    async function handleCityFormSubmit(event) {
      var form = event.target.closest('.r9-preview-calendar-form');
      if (!form || !root.contains(form)) return;
      event.preventDefault();
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      var cityInput = form.querySelector('.r9-preview-calendar-input');
      var cityName = normalizeCityName(cityInput && cityInput.value);
      var dialog = form.closest('[data-r9-city-dialog]');
      var status = form.querySelector('[data-r9-city-status]');
      var storedSubmission = getStoredCitySubmission();

      if (storedSubmission) {
        showCityResult(
          dialog,
          'duplicate',
          storedSubmission.city,
          dialog.dataset.r9CityDuplicate || "You've already submitted a city in the last 24 hours.",
        );
        return;
      }

      if (status) {
        status.textContent = 'Sending…';
        status.classList.remove('r9-is-error', 'r9-is-success', 'r9-is-duplicate');
      }
      setCitySubmitState(form, true);

      try {
        var endpoint = String(dialog.dataset.r9CityEndpoint || '').trim();
        if (!endpoint) throw new Error('Submission service is unavailable.');

        var response = await window.fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            city: cityName,
            device_id: getCityDeviceId(),
            shop: window.location.hostname,
          }),
        });
        var responseData = {};
        try {
          responseData = await response.json();
        } catch (error) {
          responseData = {};
        }

        if (response.status === 429 && responseData.code === 'already_submitted') {
          var duplicateCity = normalizeCityName(responseData.city) || cityName;
          storeCitySubmission(duplicateCity, responseData);
          showCityResult(
            dialog,
            'duplicate',
            duplicateCity,
            dialog.dataset.r9CityDuplicate || "You've already submitted a city in the last 24 hours.",
          );
          return;
        }

        if (!response.ok || !responseData.ok) {
          throw new Error(responseData.error || dialog.dataset.r9CityError || 'Submission failed.');
        }

        var submittedCity = normalizeCityName(responseData.city) || cityName;
        storeCitySubmission(submittedCity, responseData);
        showCityResult(
          dialog,
          'success',
          submittedCity,
          dialog.dataset.r9CitySuccess || 'Thank you! Your city suggestion has been submitted.',
        );
      } catch (error) {
        if (status) {
          status.textContent = error.message || dialog.dataset.r9CityError || 'Submission failed.';
          status.classList.remove('r9-is-success', 'r9-is-duplicate');
          status.classList.add('r9-is-error');
        }
      } finally {
        setCitySubmitState(form, false);
      }
    }

    function handleStartClick() {
      var nextIndex = activeIndex >= cards.length - 1 ? 0 : Math.max(activeIndex + 1, 1);
      navigateToStoryCard(nextIndex);
    }

    function resetWheelGesture() {
      clearTrackedTimeout(wheelGestureTimer);
      wheelGestureTimer = 0;
      wheelGestureActive = false;
    }

    function scheduleWheelGestureEnd() {
      clearTrackedTimeout(wheelGestureTimer);
      wheelGestureTimer = addTimeout(function () {
        wheelGestureTimer = 0;
        wheelGestureActive = false;
      }, wheelGestureIdleMs);
    }

    function cancelProgrammaticScrollForUserInput(preserveWheelTarget) {
      if (!preserveWheelTarget) wheelScrollTargetIndex = -1;
      if (!programmaticScrollInProgress) return;
      programmaticScrollInProgress = false;
      programmaticTargetIndex = -1;
      window.scrollTo({ left: window.scrollX, top: window.scrollY, behavior: 'auto' });
    }

    function handleViewportScroll() {
      requestUpdate();
    }

    function handleViewportScrollEnd(event) {
      if (event && event.target !== document) return;
      if (programmaticScrollInProgress) {
        var metrics = getMetrics();
        var progress = (window.scrollY - metrics.top) / Math.max(metrics.step, 1);
        if (Math.abs(progress - programmaticTargetIndex) <= 0.01) {
          programmaticScrollInProgress = false;
          programmaticTargetIndex = -1;
          wheelScrollTargetIndex = -1;
        }
        requestUpdate();
      }
    }

    function handleWheel(event) {
      if (
        root.classList.contains('r9-is-static') ||
        root.classList.contains('r9-mobile-nav-open') ||
        activeCityDialog ||
        event.ctrlKey
      ) return;

      var unit = event.deltaMode === 1 ? 16 : (event.deltaMode === 2 ? window.innerHeight : 1);
      var deltaX = (event.deltaX || 0) * unit;
      var deltaY = event.deltaY * unit;
      if (wheelGestureActive) {
        if (Math.max(Math.abs(deltaX), Math.abs(deltaY)) < 0.5) return;
        scheduleWheelGestureEnd();
        if (event.cancelable) event.preventDefault();
        return;
      }
      if (Math.abs(deltaY) < 0.5 || Math.abs(deltaY) <= Math.abs(deltaX)) return;

      var metrics = getMetrics();
      if (window.scrollY < metrics.top - 4 || window.scrollY > metrics.end + 4) return;
      if (root.dataset.r9WheelSnap === 'false') {
        resetWheelGesture();
        cancelProgrammaticScrollForUserInput();
        return;
      }

      var direction = Math.sign(deltaY);
      var progressIndex = clamp(Math.round(
        (window.scrollY - metrics.top) / Math.max(metrics.step, 1),
      ), 0, cards.length - 1);
      var isContinuingWheelScroll = wheelScrollTargetIndex >= 0 &&
        programmaticTargetIndex === wheelScrollTargetIndex;
      var baseIndex = isContinuingWheelScroll ? wheelScrollTargetIndex : progressIndex;
      var targetIndex = clamp(baseIndex + direction, 0, cards.length - 1);

      if (targetIndex === baseIndex) {
        var isAtPhysicalBoundary = direction < 0
          ? window.scrollY <= metrics.top + 1
          : window.scrollY >= metrics.end - 1;
        if (isAtPhysicalBoundary) {
          resetWheelGesture();
          cancelProgrammaticScrollForUserInput();
          return;
        }
        if (!event.cancelable) return;
        event.preventDefault();
        scheduleWheelGestureEnd();
        wheelGestureActive = true;
        if (!programmaticScrollInProgress) {
          scrollToIndex(baseIndex, reducedMotion.matches ? 'auto' : 'smooth', true);
          wheelScrollTargetIndex = baseIndex;
        }
        return;
      }
      if (!event.cancelable) return;
      event.preventDefault();
      scheduleWheelGestureEnd();

      wheelGestureActive = true;
      cancelProgrammaticScrollForUserInput(true);
      scrollToIndex(targetIndex, reducedMotion.matches ? 'auto' : 'smooth', true);
      wheelScrollTargetIndex = targetIndex;
    }

    function shouldBlockWheel() {
      return !root.classList.contains('r9-is-static') && (
        root.classList.contains('r9-mobile-nav-open') ||
        Boolean(activeCityDialog)
      );
    }

    function handleBlockedWheel(event) {
      if (!shouldBlockWheel() || !event.cancelable) return;
      event.preventDefault();
      resetWheelGesture();
      cancelProgrammaticScrollForUserInput();
    }

    function syncWheelBlocker() {
      var shouldAttach = shouldBlockWheel();
      if (shouldAttach === wheelBlockerAttached) return;
      wheelBlockerAttached = shouldAttach;
      if (shouldAttach) {
        window.addEventListener('wheel', handleBlockedWheel, { passive: false });
      } else {
        window.removeEventListener('wheel', handleBlockedWheel, { passive: false });
      }
    }

    function handleNavPointerMove(event) {
      if (!finePointer.matches || event.pointerType === 'touch') return;
      asArray(root.querySelectorAll('.r9-nav-item, .r9-nav-cluster-trigger')).forEach(function (item) {
        var icon = item.querySelector('.r9-nav-icon, .r9-nav-cluster-icon');
        if (!icon) return;
        var rect = icon.getBoundingClientRect();
        var distance = Math.hypot(event.clientX - (rect.left + rect.width / 2), (event.clientY - (rect.top + rect.height / 2)) * 0.7);
        var rawInfluence = clamp(1 - distance / navMagnetConfig.radius, 0, 1);
        var influence = Math.pow(rawInfluence, navMagnetConfig.falloff);
        var scale = 1 + (navMagnetConfig.maxScale - 1) * influence;
        var lift = navMagnetConfig.maxLift * influence;
        item.style.setProperty('--r9-nav-magnet-scale', scale.toFixed(4));
        item.style.setProperty('--r9-nav-magnet-lift', lift.toFixed(3) + 'px');
      });
    }

    function resetNavPointer() {
      asArray(root.querySelectorAll('.r9-nav-item, .r9-nav-cluster-trigger')).forEach(function (item) {
        item.style.setProperty('--r9-nav-magnet-scale', '1');
        item.style.setProperty('--r9-nav-magnet-lift', '0px');
      });
    }

    function preloadFollowImages() {
      if (followPreloads.length || !followImages.length) return;
      followImages.forEach(function (imageConfig) {
        var image = new Image();
        image.decoding = 'async';
        image.src = imageConfig.src;
        if (image.decode) image.decode().catch(function () {});
        followPreloads.push(image);
      });
    }

    function preparePointerPool() {
      if (!pointerLayer || pointerPool.length || !followImages.length) return;
      for (var index = 0; index < introMouseFollowConfig.poolSize; index += 1) {
        var image = document.createElement('img');
        image.className = 'r9-intro-follow-image';
        image.alt = '';
        image.decoding = 'async';
        image.draggable = false;
        image.style.setProperty('--r9-follow-width', '0px');
        image.addEventListener('animationend', function (animationEvent) {
          animationEvent.currentTarget.classList.remove('r9-is-playing');
        });
        pointerLayer.appendChild(image);
        pointerPool.push(image);
        pointerTimers.push(0);
      }
    }

    function resetIntroMouseFollow() {
      pointerPool.forEach(function (image, index) {
        clearTrackedTimeout(pointerTimers[index]);
        pointerTimers[index] = 0;
        image.classList.remove('r9-is-playing');
        image.style.opacity = '0';
      });
      lastPointer = { x: 0, y: 0, time: 0 };
    }

    function handleStagePointerMove(event) {
      if (
        !pointerLayer ||
        event.pointerType === 'touch' ||
        reducedMotion.matches ||
        !finePointer.matches ||
        root.dataset.r9ActiveSection !== 'intro' ||
        !followImages.length
      ) return;

      var rectangle = pointerLayer.getBoundingClientRect();
      var x = event.clientX - rectangle.left;
      var y = event.clientY - rectangle.top;
      if (x < 0 || y < 0 || x > rectangle.width || y > rectangle.height) return;

      var now = window.performance.now();
      var distance = Math.hypot(x - lastPointer.x, y - lastPointer.y);
      if (
        lastPointer.time &&
        (distance < introMouseFollowConfig.minDistance || now - lastPointer.time < introMouseFollowConfig.minInterval)
      ) return;

      preparePointerPool();
      if (!pointerPool.length) return;
      var poolIndex = pointerIndex % pointerPool.length;
      var image = pointerPool[poolIndex];
      var imageConfig = followImages[pointerIndex % followImages.length];
      var viewportScale = rectangle.width / introMouseFollowConfig.baseViewportWidth;
      var velocityX = lastPointer.time ? x - lastPointer.x : 0;
      var velocityY = lastPointer.time ? y - lastPointer.y : 0;
      var rotation = clamp(velocityX * 0.046 + velocityY * 0.015, -7, 7);
      var width = imageConfig.width * viewportScale * introMouseFollowConfig.imageScale;
      var driftX = clamp(velocityX * 0.42, -introMouseFollowConfig.driftMax, introMouseFollowConfig.driftMax);
      var driftY = clamp(velocityY * 0.42, -introMouseFollowConfig.driftMax, introMouseFollowConfig.driftMax);

      clearTrackedTimeout(pointerTimers[poolIndex]);
      image.classList.remove('r9-is-playing');
      image.style.opacity = '';
      image.style.setProperty('--r9-follow-width', width.toFixed(2) + 'px');
      image.style.setProperty('--r9-follow-x', x.toFixed(2) + 'px');
      image.style.setProperty('--r9-follow-y', y.toFixed(2) + 'px');
      image.style.setProperty('--r9-follow-mid-drift-x', (driftX * 0.58).toFixed(2) + 'px');
      image.style.setProperty('--r9-follow-mid-drift-y', (driftY * 0.58).toFixed(2) + 'px');
      image.style.setProperty('--r9-follow-drift-x', driftX.toFixed(2) + 'px');
      image.style.setProperty('--r9-follow-drift-y', driftY.toFixed(2) + 'px');
      image.style.setProperty('--r9-follow-rotate-start', (rotation * 0.22).toFixed(2) + 'deg');
      image.style.setProperty('--r9-follow-rotate', rotation.toFixed(2) + 'deg');
      image.style.setProperty('--r9-follow-rotate-mid', (rotation * 0.82).toFixed(2) + 'deg');
      image.style.setProperty('--r9-follow-rotate-end', (rotation * 0.35).toFixed(2) + 'deg');
      image.src = imageConfig.src;
      void image.offsetWidth;
      image.classList.add('r9-is-playing');
      pointerTimers[poolIndex] = addTimeout(function () {
        image.classList.remove('r9-is-playing');
      }, introMouseFollowConfig.lifetime);

      pointerIndex += 1;
      lastPointer = { x: x, y: y, time: now };
    }

    function updateSocialOrbitPlayback() {
      socialOrbitMotion.frame = 0;
      if (!socialOrbitRing) return;
      socialOrbitMotion.rate += (
        socialOrbitMotion.targetRate - socialOrbitMotion.rate
      ) * socialOrbitConfig.easing;
      var animations = socialOrbitRing.getAnimations ? socialOrbitRing.getAnimations() : [];
      animations.forEach(function (animation) {
        animation.updatePlaybackRate(socialOrbitMotion.rate);
      });
      if (Math.abs(socialOrbitMotion.rate - socialOrbitMotion.targetRate) > 0.002) {
        socialOrbitMotion.frame = window.requestAnimationFrame(updateSocialOrbitPlayback);
        return;
      }
      socialOrbitMotion.rate = socialOrbitMotion.targetRate;
      animations.forEach(function (animation) {
        animation.updatePlaybackRate(socialOrbitMotion.rate);
      });
    }

    function setSocialOrbitTargetRate(rate) {
      socialOrbitMotion.targetRate = rate;
      if (!socialOrbitMotion.frame) {
        socialOrbitMotion.frame = window.requestAnimationFrame(updateSocialOrbitPlayback);
      }
    }

    function handleSeriesPointer(event) {
      var item = event.target.closest('[data-r9-hover-index]');
      if (!item || !root.contains(item)) return;
      var card = item.closest('[data-r9-series-card]');
      if (!card) return;
      var active = Number(item.dataset.r9HoverIndex || 0);
      card.classList.add('r9-is-hovering');
      asArray(card.querySelectorAll('.r9-online-series-item')).forEach(function (seriesItem, index) {
        seriesItem.classList.toggle('r9-is-active', index === active);
      });
      asArray(card.querySelectorAll('.r9-hover-reveal-panel')).forEach(function (panel, index) {
        panel.classList.toggle('r9-is-active', index === active);
        panel.classList.toggle('r9-is-before', index < active);
        panel.classList.toggle('r9-is-after', index > active);
      });
    }

    function moveSeriesPointer(event) {
      var card = event.target.closest('[data-r9-series-card]');
      if (!card || !root.contains(card)) return;
      var rectangle = card.getBoundingClientRect();
      card.style.setProperty('--r9-hover-x', (event.clientX - rectangle.left).toFixed(2) + 'px');
      card.style.setProperty('--r9-hover-y', (event.clientY - rectangle.top).toFixed(2) + 'px');
    }

    function clearSeriesPointer(event) {
      var card = event.target.closest('[data-r9-series-card]');
      if (!card || !root.contains(card) || card.contains(event.relatedTarget)) return;
      card.classList.remove('r9-is-hovering');
      asArray(card.querySelectorAll('.r9-online-series-item, .r9-hover-reveal-panel')).forEach(function (element) {
        element.classList.remove('r9-is-active', 'r9-is-before', 'r9-is-after');
      });
    }

    function applyMotionMode() {
      var shouldBeStatic = reducedMotion.matches;
      root.classList.toggle('r9-is-static', shouldBeStatic);
      root.classList.toggle('r9-is-enhanced', !shouldBeStatic);
      resetWheelGesture();
      programmaticScrollInProgress = false;
      programmaticTargetIndex = -1;
      wheelScrollTargetIndex = -1;
      cardPosesInitialized = false;
      poseWindowStart = 0;
      poseWindowEnd = -1;
      renderedActiveIndex = -1;
      updateCoverStepControls(cards[activeIndex] || cards[0]);
      if (shouldBeStatic) {
        if (frame) window.cancelAnimationFrame(frame);
        frame = 0;
        cards.forEach(resetCardPose);
        updateTheme(cards[activeIndex] || cards[0]);
        syncMobileSharePosition(cards[activeIndex] || cards[0]);
      } else {
        syncDeckHeight();
        requestUpdate();
      }
      syncWheelBlocker();
    }

    function handleResize() {
      var previousMetrics = getMetrics();
      var preserveCurrentCard = !root.classList.contains('r9-is-static') &&
        window.scrollY >= previousMetrics.top - 4 &&
        window.scrollY <= previousMetrics.end + 4;
      var preservedIndex = programmaticTargetIndex >= 0
        ? programmaticTargetIndex
        : clamp(Math.round(
          (window.scrollY - previousMetrics.top) / Math.max(previousMetrics.step, 1),
        ), 0, cards.length - 1);
      resetWheelGesture();
      programmaticScrollInProgress = false;
      programmaticTargetIndex = -1;
      wheelScrollTargetIndex = -1;
      var nextMobileViewport = mobileViewport.matches;
      if (nextMobileViewport !== lastMobileViewport) {
        lastMobileViewport = nextMobileViewport;
        renderedActiveIndex = -1;
      }
      if (window.innerWidth > 760) {
        closeMobileNavigation(false);
      }
      syncDeckHeight();
      if (preserveCurrentCard) {
        var nextMetrics = getMetrics();
        window.scrollTo({
          left: window.scrollX,
          top: nextMetrics.top + nextMetrics.step * preservedIndex,
          behavior: 'auto',
        });
      }
      syncWheelBlocker();
      requestCopyFit();
      requestUpdate();
      window.requestAnimationFrame(function () {
        syncMobileSharePosition(cards[activeIndex] || cards[0]);
        updateMobileNavScrollHints();
      });
    }

    listen(root, 'click', handleRootClick);
    listen(root, 'keydown', handleRootKeydown);
    listen(window, 'keydown', handleCardNavigationKeydown);
    listen(root, 'submit', handleCityFormSubmit);
    listen(startButton, 'click', handleStartClick);
    listen(root, 'mousedown', spawnClickEffect);
    listen(window, 'scroll', handleViewportScroll, { passive: true });
    listen(window, 'resize', handleResize, { passive: true });
    listen(window, 'orientationchange', handleResize, { passive: true });
    listen(window, 'wheel', handleWheel, { passive: false });
    if (supportsScrollEnd) listen(document, 'scrollend', handleViewportScrollEnd, { passive: true });
    listen(chapterNav, 'pointermove', handleNavPointerMove, { passive: true });
    listen(chapterNav, 'pointerleave', resetNavPointer);
    listen(stage, 'pointerdown', handleSwipePointerDown, { passive: true });
    listen(stage, 'pointerup', handleSwipePointerUp, { passive: true });
    listen(stage, 'pointercancel', resetSwipePointer, { passive: true });
    listen(mobileProgress, 'pointerdown', handleMobileNavPointerDown, { passive: true });
    listen(mobileProgress, 'pointerup', handleMobileNavPointerUp, { passive: true });
    listen(mobileProgress, 'pointercancel', resetMobileNavSwipePointer, { passive: true });
    listen(mobileProgress, 'scroll', updateMobileNavScrollHints, { passive: true });
    listen(stage, 'pointermove', handleStagePointerMove, { passive: true });
    listen(stage, 'pointerleave', resetIntroMouseFollow);
    listen(root, 'pointerover', handleSeriesPointer);
    listen(root, 'pointermove', moveSeriesPointer, { passive: true });
    listen(root, 'pointerout', clearSeriesPointer);
    listen(socialOrbitRingFrame, 'pointerenter', function () {
      setSocialOrbitTargetRate(socialOrbitConfig.hoverRate);
    });
    listen(socialOrbitRingFrame, 'pointerleave', function () {
      setSocialOrbitTargetRate(socialOrbitConfig.normalRate);
    });

    if (reducedMotion.addEventListener) listen(reducedMotion, 'change', applyMotionMode);
    else if (reducedMotion.addListener) {
      reducedMotion.addListener(applyMotionMode);
      cleanups.push(function () { reducedMotion.removeListener(applyMotionMode); });
    }

    var observer = null;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        visible = entries.some(function (entry) { return entry.isIntersecting; });
        if (visible) requestUpdate();
      }, { rootMargin: '120px 0px' });
      observer.observe(deck);
      cleanups.push(function () { observer.disconnect(); });
    }

    controllers.set(root, {
      destroy: function () {
        if (frame) window.cancelAnimationFrame(frame);
        if (copyFitFrame) window.cancelAnimationFrame(copyFitFrame);
        if (socialOrbitMotion.frame) window.cancelAnimationFrame(socialOrbitMotion.frame);
        if (activeCityDialog) {
          var openDialog = activeCityDialog;
          var openDialogCard = openDialog.closest('.r9-preview-calendar-card');
          if (openDialogCard) openDialogCard.classList.remove('r9-is-response-open');
          openDialog.setAttribute('aria-hidden', 'true');
          openDialog.setAttribute('inert', '');
          openDialog.hidden = true;
          if (activeCityTrigger) activeCityTrigger.setAttribute('aria-expanded', 'false');
        }
        activeCityDialog = null;
        activeCityTrigger = null;
        restoreInteractionIsolation();
        if (wheelBlockerAttached) {
          window.removeEventListener('wheel', handleBlockedWheel, { passive: false });
          wheelBlockerAttached = false;
        }
        clearTrackedTimeout(cityFocusTimer);
        clearTrackedTimeout(cityDialogHideTimer);
        cityFocusTimer = 0;
        cityDialogHideTimer = 0;
        resetIntroMouseFollow();
        resetSwipePointer();
        resetMobileNavSwipePointer();
        resetWheelGesture();
        programmaticScrollInProgress = false;
        programmaticTargetIndex = -1;
        wheelScrollTargetIndex = -1;
        deckMetrics = null;
        cardPosesInitialized = false;
        poseWindowStart = 0;
        poseWindowEnd = -1;
        renderedActiveIndex = -1;
        suppressNextClick = false;
        clearTrackedTimeout(suppressClickTimer);
        suppressClickTimer = 0;
        cleanups.splice(0).forEach(function (cleanup) { cleanup(); });
        timeouts.forEach(function (id) { window.clearTimeout(id); });
        timeouts.clear();
        pointerPool.forEach(function (image) { image.remove(); });
        pointerPool.length = 0;
        pointerTimers.length = 0;
        followPreloads.length = 0;
        mobileNavItems.length = 0;
        activeMobileNavSection = '';
        if (mobileProgress) {
          while (mobileProgress.firstChild) mobileProgress.removeChild(mobileProgress.firstChild);
        }
        if (clickEffectsLayer) clickEffectsLayer.remove();
        if (startButton) startButton.style.removeProperty('--r9-mobile-share-bottom');
        if (coverControls) coverControls.hidden = true;
        cards.forEach(function (card) {
          card.classList.remove('r9-copy-dense', 'r9-copy-tight');
        });
        cards.forEach(resetCardPose);
        themeClasses.forEach(function (name) { root.classList.remove(name); });
        root.classList.remove('r9-is-enhanced', 'r9-theme-light-ui', 'r9-theme-dark-ui', 'r9-mobile-nav-open', 'r9-is-deck-preloading');
        root.classList.add('r9-is-static');
      },
    });

    navMeta = buildNavMeta();
    buildMobileNavStatus();
    preloadFollowImages();
    syncDeckHeight();
    requestCopyFit();
    applyMotionMode();

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        deckMetrics = null;
        requestCopyFit();
        requestUpdate();
      });
    }

    var initialHash = window.location.hash.replace(/^#/, '');
    if (initialHash && cards.some(function (card) { return card.dataset.r9Section === initialHash; }) && !reducedMotion.matches) {
      window.requestAnimationFrame(function () { scrollToSection(initialHash, 'auto'); });
    } else {
      updateTheme(cards[0]);
      updateNavigation(cards[0], 0);
      updateStartButton();
      updateCoverStepControls(cards[0]);
      requestUpdate();
    }
    window.requestAnimationFrame(function () {
      requestUpdate();
      window.requestAnimationFrame(function () {
        root.classList.remove('r9-is-deck-preloading');
      });
    });

    var storedCitySubmission = getStoredCitySubmission();
    if (storedCitySubmission) renderSubmittedCity(storedCitySubmission.city);
  }

  function destroyAnniversary(root) {
    var controller = root ? controllers.get(root) : null;
    if (!controller) return;
    controller.destroy();
    controllers.delete(root);
    syncAnniversaryPageClass(root);
  }

  function refreshAnniversaries() {
    getAnniversaryRoots().forEach(initAnniversary);
    syncAnniversaryPageClass();
  }

  function findRootBySectionId(sectionId) {
    return getAnniversaryRoots().find(function (root) {
      return String(root.dataset.r9SectionId) === String(sectionId);
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = findRootBySectionId(event.detail && event.detail.sectionId);
    if (root) initAnniversary(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = findRootBySectionId(event.detail && event.detail.sectionId);
    if (root) destroyAnniversary(root);
  });

  window.Rolife9thAnniversary = {
    init: initAnniversary,
    destroy: destroyAnniversary,
    refresh: refreshAnniversaries,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAnniversaries, { once: true });
  } else {
    refreshAnniversaries();
  }
})();
